import * as types from './actionTypes';

export const toggleUpdateNotificationModal = () => ({
    type: types.TOGGLE_MODAL_UPDATE_NOTIFICATION
});

export const showUpdateNotificationModal = () => {
    const expirationDate = new Date('2026-02-01');
    const today = new Date();

    if (today < expirationDate) {
        return {
            type: types.TOGGLE_MODAL_UPDATE_NOTIFICATION
        };
    }

    // Return a no-op action if the date has passed
    return {
        type: 'NO_OP'
    };
};
